export default {
  state:{
    beforeRouterPath:'/'
  },
  mutations:{
    UPDATE_BEFORE_ROUTERPATH(state, newValue){
      state.beforeRouterPath = newValue
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/router.js